import { Helmet } from "react-helmet";

import { linkToParentDashboard } from "features/parents/links";
import { useIsPlurallApp } from "features/plurall";
import { linkToSignUpParent } from "features/sign-up/links";
import { linkToTeacherDashboard } from "features/teachers/links";

export default function SmartAppBanner() {
  const { pathname } = window.location;

  const isPlurallApp = useIsPlurallApp();

  const isParent = pathname.includes(linkToParentDashboard());
  const isTeacher = pathname.includes(linkToTeacherDashboard());
  const isParentSignUpURL = pathname.includes(linkToSignUpParent());

  const hideBanner = !(isParent || isTeacher || isParentSignUpURL);

  if (hideBanner || isPlurallApp) return null;

  return (
    <Helmet>
      <meta
        name="apple-itunes-app"
        content="app-id=1631302657, affiliate-data=pt=125219051&ct=smart-app-banner"
      />
    </Helmet>
  );
}
